import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import styles from './runcode-btn.css';

const RunCodeBtnComponent = function (props) {
    const {
        active,
        className,
        onClick,
        title,
        imgSrc,
        ...componentProps
    } = props;
    return (
        <img
            className={classNames(
                className,
                styles.btn,
                {
                    [styles.isActive]: active
                }
            )}
            draggable={false}
            src={imgSrc}
            title={title}
            onClick={onClick}
            {...componentProps}
        />
    );
};

RunCodeBtnComponent.propTypes = {
    active: PropTypes.bool,
    className: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    title: PropTypes.string,
    imgSrc: PropTypes.string,
};

RunCodeBtnComponent.defaultProps = {
    active: false,
    title: ''
};

export default RunCodeBtnComponent;
